<template>
  <div>
    <b-card class="p-0 filter-card rounded-lg">
      <center v-if="load">
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </center>
      <b-row v-else>
        <b-col
          cols="12"
          class="p-1"
        >
          <b-form
            class="chat-app-form"
            @submit.prevent="submitOuterEmployee"
          >
            <validation-observer
              ref="outerEmployeeForm"
              class="w-100"
            >
              <b-row>
                <b-col
                  md="6"
                  sm="12"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="full_name"
                    vid="full_name"
                    rules="required"
                  >
                    <b-form-group
                      label="الاسم الكامل *"
                      label-for="full_name"
                    >
                      <b-input-group class="input-group-merge form-send-message mr-1">
                        <b-form-input
                          v-model="outerEmployee.full_name"
                          placeholder="الاسم الكامل"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="6"
                  sm="12"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="national_id"
                    vid="national_id"
                    rules="required|national_id"
                  >
                    <b-form-group
                      label="الرقم القومي *"
                      label-for="national_id"
                    >
                      <b-input-group class="input-group-merge form-send-message mr-1">
                        <b-form-input
                          v-model="outerEmployee.national_id"
                          placeholder="الرقم القومي"
                          maxlength="14"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>

                <b-col
                  md="12"
                  class="mb-2"
                >
                  <h4 class="mb-2">
                    أرقام الهواتف *
                  </h4>
                </b-col>

                <b-col
                  v-for="(phone, index) in outerEmployee.phones"
                  :key="`phone-${index}`"
                  md="12"
                  class="mb-2"
                >
                  <b-row>
                    <b-col
                      md="4"
                      sm="12"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="`phone_${index}`"
                        :vid="`phone_${index}`"
                        rules="required|phone"
                      >
                        <b-form-group
                          label="رقم الهاتف *"
                          :label-for="`phone_${index}`"
                        >
                          <b-input-group class="input-group-merge">
                            <b-form-input
                              :id="`phone_${index}`"
                              v-model="phone.phone_number"
                              placeholder="أدخل رقم الهاتف"
                              @input="sanitizePhoneNumber(index)"
                              @paste="sanitizePhoneNumberOnPaste(index, $event)"
                            />
                          </b-input-group>
                        </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                    <b-col
                      md="3"
                      sm="12"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="`phone_type_${index}`"
                        :vid="`phone_type_${index}`"
                        rules="required"
                      >
                        <b-form-group
                          label="نوع الهاتف *"
                          :label-for="`phone_type_${index}`"
                        >
                          <v-select
                            v-model="phone.phone_type"
                            :options="phoneTypeOptions"
                            :reduce="val => val.value"
                            :get-option-label="option => option.label"
                          />
                        </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                    <b-col
                      md="3"
                      sm="12"
                      class="pt-4"
                    >
                      <b-form-checkbox
                        v-model="phone.is_primary"
                        @change="setPrimaryPhone(index)"
                      >
                        الهاتف الأساسي
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                      md="2"
                      sm="12"
                      class="pt-4"
                    >
                      <div class="d-flex">
                        <feather-icon
                          v-if="outerEmployee.phones.length > 1"
                          icon="TrashIcon"
                          class="text-danger"
                          style="cursor: pointer;"
                          size="20"
                          @click="removePhone(index)"
                        />
                        <feather-icon
                          icon="PlusIcon"
                          class="text-primary ml-2"
                          style="cursor: pointer;"
                          size="20"
                          @click="addPhone"
                        />
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </validation-observer>
          </b-form>
          <div class="d-flex justify-content-end">
            <b-button
              variant="primary"
              class="rounded-pill mt-2"
              type="submit"
              @click="submitOuterEmployee"
            >
              حفظ
            </b-button>
            <b-button
              class="rounded-pill mt-2 ml-1"
              @click="$router.push({ name: 'employees' })"
            >
              إلغاء
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BButton,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BInputGroup,
  BForm,
  BFormInput,
  BFormCheckbox,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, phone, national_id } from '@validations'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    BButton,
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormInput,
    BFormCheckbox,
    BSpinner,
    FeatherIcon,
  },
  computed: {
    ...mapGetters({
      load: 'employees/load',
    }),
    phoneTypeOptions() {
      return [
        { value: 'mobile', label: 'موبايل' },
        { value: 'whatsapp', label: 'واتساب' },
        { value: 'landline', label: 'أرضي' },
      ]
    },
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      outerEmployee: {
        full_name: null,
        national_id: null,
        phones: [
          {
            phone_number: null,
            phone_type: 'mobile',
            is_primary: true,
          },
        ],
      },
    }
  },
  mounted() {
    // Component is ready
  },
  methods: {
    sanitizePhoneNumber(index) {
      if (this.outerEmployee.phones[index] && this.outerEmployee.phones[index].phone_number) {
        let phoneNumber = this.outerEmployee.phones[index].phone_number
        // Keep leading + if present, then remove all non-digit characters
        const hasPlus = phoneNumber.trim().startsWith('+')
        phoneNumber = phoneNumber.replace(/\D/g, '') // Remove all non-digits
        // Restore leading + if it was there and we have digits
        if (hasPlus && phoneNumber.length > 0) {
          phoneNumber = `+${phoneNumber}`
        }
        this.$set(this.outerEmployee.phones[index], 'phone_number', phoneNumber)
      }
    },
    sanitizePhoneNumberOnPaste(index, event) {
      // Use setTimeout to access the pasted value after paste event completes
      setTimeout(() => {
        this.sanitizePhoneNumber(index)
      }, 0)
    },
    addPhone() {
      this.outerEmployee.phones.push({
        phone_number: null,
        phone_type: 'mobile',
        is_primary: false,
      })
    },
    removePhone(index) {
      if (this.outerEmployee.phones.length > 1) {
        // If removing primary phone, make first phone primary
        if (this.outerEmployee.phones[index].is_primary) {
          this.outerEmployee.phones[0].is_primary = true
        }
        this.outerEmployee.phones.splice(index, 1)
      }
    },
    setPrimaryPhone(index) {
      // Ensure only one phone is primary
      this.outerEmployee.phones.forEach((phone, i) => {
        if (i !== index) {
          phone.is_primary = false
        }
      })
    },
    submitOuterEmployee() {
      this.$refs.outerEmployeeForm.validate().then(success => {
        if (success) {
          // Ensure at least one phone is primary
          const hasPrimary = this.outerEmployee.phones.some(phone => phone.is_primary)
          if (!hasPrimary && this.outerEmployee.phones.length > 0) {
            this.outerEmployee.phones[0].is_primary = true
          }

          // Prepare payload according to API spec
          const payload = {
            full_name: this.outerEmployee.full_name,
            national_id: this.outerEmployee.national_id,
            phones: this.outerEmployee.phones.map(phone => ({
              phone_number: phone.phone_number,
              phone_type: phone.phone_type,
              is_primary: phone.is_primary || false,
            })),
          }

          this.$store.dispatch('employees/storeOuter', { query: payload }).then(res => {
            this.$swal({
              icon: 'success',
              title: `<h4>${res.message}</h4>`,
              showConfirmButton: true,
              confirmButtonColor: '#06284D',
              allowOutsideClick: true,
            }).then(() => {
              this.$router.push({ name: 'employees' })
            })
          }).catch(error => {
            if (error.response) {
              let errorMessage = error.response.data.message || 'حدث خطأ'
              if (error.response.data.errors) {
                // Handle validation errors
                const { errors } = error.response.data
                const errorList = Object.keys(errors).map(key => errors[key].join(', ')).join('<br>')
                errorMessage = errorList
              }
              this.$swal({
                icon: 'error',
                title: `<h4>${errorMessage}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#06284D',
                allowOutsideClick: true,
              })
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
.input-group .form-control {
    background-color: #fff !important;
}
</style>
